import React from "react";
import Layout from "../components/layout";
import { Text } from "../components/Text";
import Rating from "../components/rating";
import { languages } from "./languages.data";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "./utils/useMediaQuery";

const LanguagesPage = () => {
  const isXS = useMediaQuery("(max-width: 600px)");
  const { t } = useTranslation();
  return (
    <Layout title={t("language_title")}>
      <div className="grid gap-4 grid-cols-[auto_auto_1fr] items-center">
        {languages.map((language) => (
          <React.Fragment key={language.code}>
            <language.flag className="mr-2 w-8 h-6 skew-x-[-7.125deg]" />
              <div>
                <Text variant="body1">{t(language.name)}</Text>
                <Text variant="caption">{t(language.levelKey)}</Text>
              </div>
            <Rating
              value={language.level * (isXS ? 1 : 2)}
              total={isXS ? 6 : 12}
            />
          </React.Fragment>
        ))}
      </div>
    </Layout>
  );
};

export default LanguagesPage;
